import { vue } from '@/main'

export default function () {
  return [

    {
      key: 'affiliateIds',
      type: 'affiliate',
      label: vue.$t('affiliate'),
      props: {
        clearable: true,
        multiple: true
      }
    },
    // The desk filter is auto-injected by FilterCard right before the first
    // 'org' field, so the visible order is: affiliate, desk, org, bu.
    {
      key: 'orgIds',
      type: 'org',
      props: {
        clearable: true,
        multiple: true
      }
    },
    {
      key: 'buIds',
      label: 'businessUnit',
      type: 'bu',
      props: {
        clearable: true,
        multiple: true
      }
    },

  ]
}
